var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomerSupportIcon = function SvgCustomerSupportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1A1A",
    strokeWidth: 1.25,
    d: "M17.405 13.365V8.654a7.404 7.404 0 1 0-14.808 0v4.711"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1A1A",
    strokeWidth: 1.25,
    d: "M17.402 12.02a6.06 6.06 0 0 1-6.057 6.058h-2.02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FC",
    stroke: "#1A1A1A",
    strokeWidth: 1.25,
    d: "M1.875 11.347a1.394 1.394 0 1 1 2.788 0v1.347a1.394 1.394 0 0 1-2.788 0zM15.336 11.347a1.394 1.394 0 0 1 2.788 0v1.347a1.394 1.394 0 1 1-2.788 0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.998,
    cy: 18.081,
    r: 1.346,
    fill: "#1A1A1A"
  })));
};
export default SvgCustomerSupportIcon;